import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Button from "@mui/material/Button/Button";
import { AiOutlineMenu, AiOutlineHeart } from "react-icons/ai";
import { IoWalletOutline, IoFlashOutline } from "react-icons/io5";
import { IoMdFingerPrint } from "react-icons/io";
import { GiVikingHelmet } from "react-icons/gi";
import { AiOutlineShopping } from "react-icons/ai";
import { AiOutlinePaperClip } from "react-icons/ai";
import { GrFormClose } from "react-icons/gr";
import { AiOutlineCompass } from "react-icons/ai";
import { MdOutlineTitle } from "react-icons/md";
import { GiSpeedBoat } from "react-icons/gi";
import { AiOutlineTool } from "react-icons/ai";
import { RiGalleryLine, RiDiscordFill } from "react-icons/ri";
import { BsBook, BsStars } from "react-icons/bs";

import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";

import Dis from "../../assets/images/dis.svg";
import Insta from "../../assets/images/insta.svg";
import Twitter from "../../assets/images/twitter.svg";
import OpenSea from "../../assets/images/openSea.svg";
import Logo from "../../assets/images/Angry_dwarve_logo.png";
import Wallet from "../../assets/images/WalletSvg";

import "./Header.scss";

const Header = () => {
  const history = useHistory();

  const [state, setState] = React.useState({
    right: false,
  });
  const [hide, setHide] = useState(false);

  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const navbarLink1 = () => {
    window.open("https://nftbible.store/", "_blank");
  };
  const navbarLink2 = () => {
    window.open(
      "https://angry-dwarves-nft.gitbook.io/welcome-to-gitbook/",
      "_blank"
    );
  };
  const goToLink = (li) => {
    history.push(`/${li}`);
    setState({ right: false });
  };

  useEffect(() => {
    if (history.location.pathname == "/dashboard") {
      setHide(true);
    } else {
      setHide(false);
    }
  }, [history.location.pathname]);

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div className="slider_container">
        <div className="title">
          <GiVikingHelmet style={{ marginLeft: "2.6%", color: "#ffde00" }} />
          <p> Angry Dwarves </p>
          <Button className="closebtn" onClick={toggleDrawer("right", false)}>
            {" "}
            <GrFormClose />{" "}
          </Button>
        </div>
        <div className="listdata">
          <div className="pointer itm" onClick={navbarLink2}>
            <AiOutlinePaperClip /> <p> WhitePaper </p>
          </div>
          {/* <div className="pointer itm" onClick={() => goToLink("#")} >
                        <GiSpeedBoat /> <p> Git Book </p>
                    </div> */}
          {/* <div className="pointer itm" onClick={() => goToLink("#team")} >
                        <MdOutlineTitle /> <p> Title </p>
                    </div> */}
          <div className="pointer itm" onClick={navbarLink1}>
            <AiOutlineShopping /> <p> NFT BiBLE </p>
          </div>

          {/* <div className="pointer vbtn" onClick={() => goToLink("#")} >
                        <IoWalletOutline /> <p> Connect Wallet </p>
                    </div> */}
        </div>

        <div className="slider_social">
          {/* <img src={Dis} alt="ERROR" />
                    <img src={Twitter} alt="ERROR" /> */}
          {/* <img src={OpenSea} alt="ERROR" /> */}
          {/* <img src={Insta} alt="ERROR" /> */}
        </div>
      </div>
    </Box>
  );

  const Link1 = () => {
    window.open(
      "https://angry-dwarves-nft.gitbook.io/welcome-to-gitbook/",
      "_blank"
    );
  };

  const Link2 = () => {
    window.open(
      "https://angry-dwarves-nft.gitbook.io/welcome-to-gitbook/",
      "_blank"
    );
  };

  return (
    <>
      <div
        className="header_container"
        style={{ display: hide ? "none" : null }}
      >
        <div className="heading">
          {/* <p> NEXT PUBLIC SALE COMING SOON </p> */}
        </div>
        <div className="navb">
          <div className="social">
            <a href="https://discord.com/invite/QTsHxHtj9k" target="_blank">
              <img src={Dis} alt="ERROR" />
            </a>
            <a href="https://twitter.com/angrydwarvesNFT" target="_blank">
              <img src={Twitter} alt="ERROR" />
            </a>

            {/* <img src={OpenSea} alt="ERROR" /> */}
            {/* <a href='https://nftbible.store/' target="_blank" style={{ textDecoration: 'none' }}><p style={{ marginLeft: "1rem", color: "#ffde00" }}> Title </p></a> */}

            <a
              href="https://nftbible.store/"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <p
                style={{
                  marginLeft: "0.5rem",
                  color: "#ffde00",
                  fontSize: "1rem",
                }}
              >
                {" "}
                NFT BiBLE{" "}
              </p>
            </a>
          </div>
          <div
            style={{ cursor: "pointer" }}
            className="logo"
            onClick={() => history.push("/")}
          >
            <img src={Logo} alt="ERROR" />
          </div>
          <div className="options">
            <p
              style={{
                marginRight: "1rem",
                color: "#ffde00",
                cursor: "pointer",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
              onClick={Link1}
            >
              {" "}
              Whitepaper{" "}
            </p>
            {/* <p style={{ color: "rgb(86, 199, 252)", cursor: "pointer" }} onClick={Link2}> Git-Book </p> */}
            <button className="mbtn2">Mint Now</button>
            <Button className="mbtn3" onClick={toggleDrawer("right", true)}>
              {" "}
              <AiOutlineMenu />{" "}
            </Button>
            <div>
              <SwipeableDrawer
                anchor="right"
                open={state["right"]}
                onClose={toggleDrawer("right", false)}
                onOpen={toggleDrawer("right", true)}
              >
                {list("right")}
              </SwipeableDrawer>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
